import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TabsModule } from '../../../tabs/tabs.module';

@Component({
    selector: 'nw-article-category-tabs-block',
    imports: [TabsModule],
    templateUrl: './article-category-tabs-block.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArticleCategoryTabsBlockComponent {
    @Input() tabs: string[] = [];
    @Input() selectedIndex: number = 0;

    public selectedIndexChange(index: number): void {
        const BASE_URL: URL = new URL(window.location.href);
        BASE_URL.searchParams.delete('page');
        BASE_URL.searchParams.delete('categories');
        BASE_URL.searchParams.append('categories', `${index === 0 ? '' : index - 1}`);

        location.assign(BASE_URL.toString());
    }
}
